/**
 * Created by Carsten Bühler
 * User: c.buehler on 14.06.2016
 * Copyright: xdot GmbH 2015
 */

import keyMirror from 'external/keymirror';

export default keyMirror({
    GeoFeature: null,
    LogicalLayer: null,
    LayerDataSource: null,
    LayerSet: null,
    MapConfig: null,
    SituationMap: null
});



// WEBPACK FOOTER //
// ./js/constants/ClassNames.js